import { createSlice } from '@reduxjs/toolkit'
import { changeStatusMenuAction } from './actions'

const INITIAL_STATE = {
  open: false
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState: INITIAL_STATE,
  reducers: {
    changeStatusMenu: changeStatusMenuAction
  }
})

export const { changeStatusMenu } = menuSlice.actions

export default menuSlice.reducer

export const useMenuStatus = state => state.menu.open